"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SET_SHOW_READINESS_CHECK = exports.SET_ATTENDEE_READINESS_CHECK = exports.BROADCAST_SET_READINESS_CHECK = exports.BROADCAST_RUN_READINESS_CHECK = exports.BROADCAST_REMOVE_SANDBOX_MEETING = exports.BROADCAST_CREATE_SANDBOX_MEETING = void 0;
var BROADCAST_CREATE_SANDBOX_MEETING = exports.BROADCAST_CREATE_SANDBOX_MEETING = 'BROADCAST_CREATE_SANDBOX_MEETING';
var BROADCAST_SET_READINESS_CHECK = exports.BROADCAST_SET_READINESS_CHECK = 'BROADCAST_SET_READINESS_CHECK';
var SET_SHOW_READINESS_CHECK = exports.SET_SHOW_READINESS_CHECK = 'SET_SHOW_READINESS_CHECK';
var BROADCAST_REMOVE_SANDBOX_MEETING = exports.BROADCAST_REMOVE_SANDBOX_MEETING = 'BROADCAST_REMOVE_SANDBOX_MEETING';
var BROADCAST_RUN_READINESS_CHECK = exports.BROADCAST_RUN_READINESS_CHECK = 'BROADCAST_RUN_READINESS_CHECK';
var SET_ATTENDEE_READINESS_CHECK = exports.SET_ATTENDEE_READINESS_CHECK = 'SET_ATTENDEE_READINESS_CHECK';